<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('datevSetting') }}
    </page-header>
    <v-card
      class="pa-4"
      elevation="0"
    >
      <div class=" mt-4">
        <div>
          <div class="font-weight-bold text-body-1">
            {{ $t('Hint') }}: {{ $t('NewestDatevHint') }}
          </div>
          <v-date-picker
            v-model="picker"
            :locale="$i18n.locale"
            :max="maxMonth"
            class="mt-4"
            type="month"
          />
        </div>
        <v-btn
          :disabled="canDownMonth > 0"
          class="mt-4 mr-2"
          color="amber lighten-4 black--text"
          elevation="0"
          @click="downDatevCsv"
        >
          <v-icon left>
            mdi-download
          </v-icon>
          {{ $t('DatevDownload') }}
        </v-btn>
        <v-btn
          :disabled="canDownMonth > 0"
          class="mt-4"
          color="blue lighten-4 black--text"
          elevation="0"
          @click="sendDatev"
        >
          <v-icon left>
            mdi-email-send-outline
          </v-icon>
          {{ $t('OnlySentToMail') }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import dayjs from 'dayjs'
import { exportManyDatevCsv } from '@/model/dataLayer/service/otherService'
import { showSuccessMessage } from '@/model/utils/utils'
import i18n from '@/i18n'
import GlobalConfig from '@/model/global/GlobalSettings'
import { getBaseAndUrlForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export default {
  name: 'DatevDownload',
  components: {
    PageHeader
  },
  data: function () {
    return ({
      maxMonth: null,
      selectDate: null,
      picker: new Date().toISOString().substr(0, 7)
    })
  },
  computed: {
    canDownMonth () {
      return dayjs(this.picker).diff(this.maxMonth, 'month')
    }
  },
  mounted () {
    this.maxMonth = dayjs(this.picker).add(-1, 'month').startOf('month').format('YYYY-MM')
  },
  methods: {
    async sendDatev () {
      const fromDate = dayjs(this.picker).format('YYYY-MM-DD HH:mm:ss')
      const toDate = dayjs(this.picker).add(1, 'month').add(1, 'second').format('YYYY-MM-DD HH:mm:ss')
      await exportManyDatevCsv(fromDate, toDate)
      showSuccessMessage(i18n.t('submit_success'))
    },
    async downDatevCsv () {
      this.selectDate = dayjs(this.picker).add(1, 'month').add(4, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const { url } = await getBaseAndUrlForDeviceId(GlobalConfig.DeviceId)
      window.open(
        url + '/PHP/Datev.php?op=exportAndDownloadDatevCsv&now=' + this.selectDate,
        '_blank')
    }
  }
}
</script>

<style scoped>

</style>
